define('collections/cd_products',['require','collections/base','models/cd_product'],function (request) {
    var BaseCollection = require('collections/base');
    var Model = require("models/cd_product");
    return BaseCollection.extend({
        model : Model,
        url:"cd-products.json"
    });
});
